import { useTheme } from '@mui/material';

export function useSectionMinHeight(): string {
  const { customSizes } = useTheme();
  // TODO check
  return `calc(100vh - ${customSizes.smallImageHeight.mobile}px)`;
}
